// extracted by mini-css-extract-plugin
module.exports = {"banner":"SimilarProductsCarousel_banner__JY3rp","grid":"SimilarProductsCarousel_grid__2PKsZ"};